import { render, staticRenderFns } from "./text-modal-with-secondary.vue?vue&type=template&id=1ebe3cce&"
import script from "./text-modal-with-secondary.vue?vue&type=script&lang=js&"
export * from "./text-modal-with-secondary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports